import React from 'react';
import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  init,
  isReady,
  getList,
  useList,
  fetch,
  addUser,
};

const g_orgUserListMap: Map<number, any[]> = new Map();

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function _addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function _removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done?.();
}
function isReady() {
  return true;
}
function getList(org_id: number) {
  return g_orgUserListMap.get(org_id);
}
function _subscribe(callback: any) {
  _addChangeListener(callback);
  return () => {
    _removeChangeListener(callback);
  };
}
export function useList(org_id: number) {
  const _get = React.useCallback(() => {
    return getList(org_id);
  }, [org_id]);
  return React.useSyncExternalStore(_subscribe, _get);
}
function fetch(org_id: number, done?: (err: any) => void) {
  const opts = {
    url: `/admin/1/org/${org_id}/user`,
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('UserAdminStore.fetch: err:', err);
    } else if (body) {
      const old = g_orgUserListMap.get(org_id);
      if (!util.deepEqual(old, body.user_list)) {
        g_orgUserListMap.set(org_id, body.user_list);
        _emit('update');
      }
    }
    done?.(err);
  });
}
function addUser(params, done) {
  const { org_id, ...other } = params;
  const opts = {
    url: `/admin/1/org/${org_id}/user`,
    body: other,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('UserAdminStore.addUser: err:', err, body);
      done(err);
    } else {
      fetch(org_id, () => done(null, body?.user_id));
    }
  });
}
